import { success, failure } from 'utilities/actions'
import * as actions from './actions'
import { subDays } from 'utilities/date'
import { TAB_OPTIONS } from 'components/pages/reportsOverviewPage/constants'
import { getTabOption } from 'components/organisms/pageTabs/helpers'

import type { ReportCountItem } from 'components/pages/reportsOverviewPage/types'

export const REPORTS_OVERVIEW_TAB_STATES = {
  inProgress: TAB_OPTIONS.inProgress.state,
  notReviewed: TAB_OPTIONS.notReviewed.state
} as const

export type State = {
  data: ReportCountItem[];
  isLoading: boolean;
  filter: Record<any, any>;
  errors: any[];
  selectedTab: string;
  searchParams?: {
    [key: string]: string;
  };
};

export type Action = any & {
  type: string;
};

export const initialFilterState = {
  filter: {
    reviewStatus: REPORTS_OVERVIEW_TAB_STATES.inProgress,
    startDate: subDays({ days:90 })
  }
} as const

export const initialState = {
  data: [],
  isLoading: false,
  errors: [],
  selectedTab: REPORTS_OVERVIEW_TAB_STATES.inProgress[0],
  ...initialFilterState
} as const

// @ts-expect-error - TS7031 - Binding element 'filter' implicitly has an 'any' type. | TS7031 - Binding element 'defaultTab' implicitly has an 'any' type.
const resolveSelectedTabFromFilter = ({ filter, defaultTab }) => {
  const { reviewStatus = [], capaStatus } = filter

  if (capaStatus) {
    return TAB_OPTIONS.capa.key
  }

  return reviewStatus[0] || defaultTab
}

// @ts-expect-error - TS7031 - Binding element 'filter' implicitly has an 'any' type. | TS7031 - Binding element 'selectedTab' implicitly has an 'any' type.
const stripReviewStatusForCapaTab = ({ filter, selectedTab }) => {
  if (selectedTab !== TAB_OPTIONS.capa.key) {
    return filter
  }

  const normalizedFilter = { ...filter } as const
  delete normalizedFilter.reviewStatus

  return normalizedFilter
}

// @ts-expect-error - TS2322 - Type '{ readonly filter: { readonly reviewStatus: readonly ["in_progress"]; readonly startDate: string; }; readonly data: readonly []; readonly isLoading: false; readonly errors: readonly []; readonly selectedTab: "in_progress"; }' is not assignable to type 'State'.
const reducer = (state: State | null | undefined = initialState, action: Action) => {
  switch (action.type) {
    case success(actions.API_REPORTS_COUNTS_INDEX):
      const { data } = action
      return {
        ...state,
        data,
        errors: [],
        isLoading: false
      }
    case failure(actions.API_REPORTS_COUNTS_INDEX):
      return {
        ...state,
        errors: action.errors,
        isLoading: false
      }
    case actions.API_REPORTS_COUNTS_SET_ALL_FILTERS:
      const { filter } = action
      const resolvedTabKey = resolveSelectedTabFromFilter({ filter, defaultTab: initialState.selectedTab })
      const normalizedFilter = stripReviewStatusForCapaTab({ filter, selectedTab: resolvedTabKey })
      // get pre-configured url params for the selected tab
      const { searchParams } = getTabOption({
// @ts-expect-error - TS2322 - Type '{ readonly inProgress: { readonly key: "in_progress"; readonly value: "in_progress"; readonly label: "In Progress"; readonly state: readonly ["in_progress"]; readonly overviewTableColumns: readonly [{ readonly displayName: "Participant group"; }, ... 4 more ..., { ...; }]; readonly filters: { ...; }; readonly search...' is not assignable to type 'TabOptionsType'. - fall through
        tabOptions: TAB_OPTIONS,
        selectedTab: resolvedTabKey
      })

      return {
        ...state,
        filter: normalizedFilter,
        searchParams,
        selectedTab: resolvedTabKey,
        isLoading: true
      }
    default:
      return state
  }
}

export default reducer
